import styled from "styled-components";
import { TextElem } from "../../../../common/text";

export const Legal: React.FC = () => {
    return (
        <Footer>
            <TextElem size="small" tid="MAMA.LEGAL.TEXT" fontFamily='RF Dewi' />
        </Footer>
    );
}
const Footer = styled.div`
width: 100%;
padding: 16px;
margin-top: auto;
`;